var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Trash_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 14.52 14.39",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.28v.66c0 .18-.15.33-.33.33H2.35c-.18 0-.33-.15-.33-.33v-.66c0-.18.15-.33.33-.33H5.3v-.66c0-.36.29-.66.66-.66h2.62c.36 0 .66.29.66.66v.66h2.95c.17 0 .31.15.31.33zM3.24 12.53c.05.69.62 1.22 1.31 1.22h5.43c.69 0 1.26-.53 1.31-1.22l.56-7.96H2.67l.57 7.96z",
    fill: "#cfd1d2"
  })));
}
export default SvgTrash;